/**
 *  Add / to pathname if is missing from the end of the string
 */
if (window.location.href.indexOf('#') !== -1 && window.location.pathname.slice(-1) !== '/') {

    window.location.pathname += `${window.location.pathname}/`;

}

(() => {

    const { defaultLanguage } = window;
    const base = window.location.pathname.split('/')[1];
    const head = document.getElementsByTagName('head')[0];
    const regEx = /^(([a-z]{2}-[a-z]{2})|([a-z]{2})|(lang))$/i;

    /**
     *   Add html tag
     */
    function addTag(tag, attrs) {

        const elem = document.createElement(tag);

        Object.keys(attrs).map((name) => {

            if (attrs[name]) {

                elem.setAttribute(name, attrs[name]);

            }

            return true;

        });

        head.appendChild(elem);

    }

    // @ToDo Replace condition with language detection regexp
    if (base.match(regEx)) {

        addTag('base', { href: ['/', base, '/'].join('') });

    } else {

        window.location.pathname = defaultLanguage + window.location.pathname;

    }

})();



// WEBPACK FOOTER //
// ./scripts/common/before-start.js